// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-3mAUwGIT","stock_box":"stock_box-3qXG3x9A"};